/* eslint-disable import/no-unresolved */
import React, { useCallback, useState } from 'react';
import { DEFAULT_PAGE_SIZE } from 'src/shared/constants/defaultVariables.consants';
import BookList from '../BookSearch/BookList';
import './NewBooksInMonth.scss';
import { getBookListInMonth } from './NewBooksInMonthApi';
import NewBooksInMonthFilter from './NewBooksInMonthFilter';

function NewBooksInMonth() {
  const [bookList, setBookList] = useState([]);
  const [totalBooks, setTotalBooks] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterValues, setFilterValues] = useState();

  const getBookList = useCallback(
    ({ groupType, month, year }) => {
      setIsLoading(true);
      getBookListInMonth({
        page: currentPage,
        pageSize: DEFAULT_PAGE_SIZE,
        groupType,
        month,
        year,
      }).then((value) => {
        setIsLoading(false);
        setBookList(value);
        setTotalBooks(value[0]?.TotalRecords ?? 0);
      });
    },
    [currentPage]
  );

  const handleFilterUpdate = (filterResults) => {
    setFilterValues(filterResults);
    getBookList(filterResults);
  };

  const handlePageChange = useCallback((page) => {
    getBookList({ page, ...filterValues });
    setCurrentPage(page);
  });

  return (
    <div className="new-books-in-month">
      <NewBooksInMonthFilter onFilterUpdate={handleFilterUpdate} />
      <BookList
        total={totalBooks}
        isLoading={isLoading}
        bookList={bookList}
        onPageChange={handlePageChange}
        currentPage={currentPage}
        pageSize={DEFAULT_PAGE_SIZE}
      />
    </div>
  );
}

export default NewBooksInMonth;
